import script from "./ResponseModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponseModal.vue?vue&type=script&setup=true&lang=js"

import "./ResponseModal.vue?vue&type=style&index=0&id=c2f62f66&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2f62f66"]])

export default __exports__